const statementsPageData = {
    header : {
        image : {
            name : "statements-2.jpg",
            alt : "Statements and plices wallpaper",
        },
    },
    title : "Statements and Policies",
    paragraphOne : "Our organisation recognizes the importance of addressing sustainability, environmental, social, and governance (ESG) issues, which are of great interest to our customers, clients, investors, and other stakeholders. To ensure consistent governance on these matters, we have established a set of policies and statements of intent that apply across our organisation, which are detailed on this page. These policies and statements reflect our commitment to promoting sustainability, environmental stewardship, social responsibility, and good governance within our operations. They encompass our environmental policies, focusing on reducing carbon emissions, conserving resources, promoting renewable energy, and minimizing waste and pollution. Additionally, they address our social policies, emphasizing diversity, inclusion, equal opportunity, human rights, labor practices, community engagement, and philanthropy. Finally, our governance policies ensure transparent and ethical practices throughout our organisation.",
    cards : [
        {
            image : {
                name : "statements-1.jpg",
                alt : "Compliance with Regulations card",
            },
            title : "Compliance with Regulations",
            linkOne : {
                title : "Compliance with regulations",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-2.jpg",
                alt : "Our Corporate Social Responsibility Policy  card",
            },
            title : "Our Corporate Social Responsibility Policy ",
            linkOne : {
                title : "Our Corporate Social Responsibility Policy ",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-1.jpg",
                alt : "Risk Documents  card",
            },
            title : "Risk Documents",
            linkOne : {
                title : "Risk Documents",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-2.jpg",
                alt : "Internal Audit  card",
            },
            title : "Internal Audit",
            linkOne : {
                title : "Internal Audit",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-1.jpg",
                alt : "Governance And Financial Crime Statements  card",
            },
            title : "Governance And Financial Crime Statements",
            linkOne : {
                title : "Governance And Financial Crime Statements",
                path : "/",
            },
        },
        {
            image : {
                name : "statements-2.jpg",
                alt : "Codes of Conduct  card",
            },
            title : "Codes of Conduct",
            linkOne : {
                title : "Codes of conduct",
                path : "/",
            },
        },

    ]
};

export default statementsPageData;